import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export enum Animal {
  Cat = 'CAT',
  Dog = 'DOG'
}

export type Mutation = {
  __typename?: 'Mutation';
  createUserResult: UserResult;
  logout: Scalars['Boolean']['output'];
  requestTwoFactorAuth: Scalars['String']['output'];
  resetMyPassword: User;
  rollApiKey: Scalars['String']['output'];
  setupTwoFactorAuth: User;
  updateEmail: User;
  updatePassword: User;
  updateUsername: User;
};


export type MutationCreateUserResultArgs = {
  userResult: CreateUserResultInput;
};


export type MutationRollApiKeyArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationSetupTwoFactorAuthArgs = {
  secret: Scalars['String']['input'];
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateUsernameArgs = {
  username: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getScenario: Scenario;
  getScenarioActionList: Array<ScenarioAction>;
  getScenarioList: Array<Scenario>;
  getScenarioStageList: Array<ScenarioStage>;
  getUser: User;
  getUserResultList: Array<UserResult>;
};


export type QueryGetScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type QueryGetScenarioActionListArgs = {
  scenarioId: Scalars['String']['input'];
};


export type QueryGetScenarioStageListArgs = {
  scenarioId: Scalars['String']['input'];
};


export type QueryGetUserResultListArgs = {
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Scenario = {
  __typename?: 'Scenario';
  animalType?: Maybe<Animal>;
  duration?: Maybe<Scalars['Int']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  hints?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postScenarioInfo?: Maybe<Scalars['String']['output']>;
  preScenarioInfo?: Maybe<Scalars['String']['output']>;
};

export type ScenarioAction = {
  __typename?: 'ScenarioAction';
  actionDelay?: Maybe<Scalars['Int']['output']>;
  bodyTemperatureVariation: Scalars['Float']['output'];
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dialog?: Maybe<Scalars['String']['output']>;
  diastolicPressureVariation: Scalars['Int']['output'];
  heartRateVariation: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  killsPet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postActionText?: Maybe<Scalars['String']['output']>;
  repeatable: Scalars['Boolean']['output'];
  respiratoryRateVariation: Scalars['Int']['output'];
  scenarioId: Scalars['String']['output'];
  subname?: Maybe<Scalars['String']['output']>;
  systolicPressureVariation: Scalars['Int']['output'];
  targetStageId?: Maybe<Scalars['String']['output']>;
  triggerDelay?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioStage = {
  __typename?: 'ScenarioStage';
  ScenarioAction?: Maybe<Array<Maybe<ScenarioAction>>>;
  conditionActionIds: Array<Scalars['String']['output']>;
  dialog?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  imgUrlAvatar?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  scenarioId: Scalars['String']['output'];
  startBodyTemperature: Scalars['Float']['output'];
  startDiastolicPressure: Scalars['Int']['output'];
  startHeartRate: Scalars['Int']['output'];
  startRespiratoryRate: Scalars['Int']['output'];
  startSystolicPressure: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserResult = {
  __typename?: 'UserResult';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  scenarioId: Scalars['String']['output'];
  scenarioLog: Array<Scalars['JSON']['output']>;
  scenarioName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CreateUserResultInput = {
  scenarioId: Scalars['String']['input'];
  scenarioLog: Array<Scalars['JSON']['input']>;
};

export type GetUsersOfOrganization = {
  __typename?: 'getUsersOfOrganization';
  cursor: Scalars['String']['output'];
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type UserFragment = { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string };

export type ScenarioFragment = { __typename?: 'Scenario', id: string, name: string, animalType?: Animal | null, duration?: number | null, preScenarioInfo?: string | null, postScenarioInfo?: string | null, hints?: string | null, goal?: string | null };

export type ScenarioActionFragment = { __typename?: 'ScenarioAction', id: string, name: string, subname?: string | null, category?: string | null, dialog?: string | null, imgUrl?: string | null, postActionText?: string | null, description?: string | null, killsPet: boolean, repeatable: boolean, targetStageId?: string | null, bodyTemperatureVariation: number, systolicPressureVariation: number, diastolicPressureVariation: number, heartRateVariation: number, respiratoryRateVariation: number, triggerDelay?: number | null, actionDelay?: number | null, scenarioId: string };

export type ScenarioStageFragment = { __typename?: 'ScenarioStage', id: string, name: string, scenarioId: string, imgUrl?: string | null, imgUrlAvatar?: string | null, order: number, time: number, dialog?: string | null, startBodyTemperature: number, startSystolicPressure: number, startDiastolicPressure: number, startHeartRate: number, startRespiratoryRate: number, conditionActionIds: Array<string>, ScenarioAction?: Array<{ __typename?: 'ScenarioAction', id: string, name: string, subname?: string | null, category?: string | null, dialog?: string | null, imgUrl?: string | null, postActionText?: string | null, description?: string | null, killsPet: boolean, repeatable: boolean, targetStageId?: string | null, bodyTemperatureVariation: number, systolicPressureVariation: number, diastolicPressureVariation: number, heartRateVariation: number, respiratoryRateVariation: number, triggerDelay?: number | null, actionDelay?: number | null, scenarioId: string } | null> | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string } };

export type GetScenarioListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScenarioListQuery = { __typename?: 'Query', getScenarioList: Array<{ __typename?: 'Scenario', id: string, name: string, animalType?: Animal | null, duration?: number | null, preScenarioInfo?: string | null, postScenarioInfo?: string | null, hints?: string | null, goal?: string | null }> };

export type GetScenarioQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type GetScenarioQuery = { __typename?: 'Query', getScenario: { __typename?: 'Scenario', id: string, name: string, animalType?: Animal | null, duration?: number | null, preScenarioInfo?: string | null, postScenarioInfo?: string | null, hints?: string | null, goal?: string | null } };

export type GetScenarioActionListQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type GetScenarioActionListQuery = { __typename?: 'Query', getScenarioActionList: Array<{ __typename?: 'ScenarioAction', id: string, name: string, subname?: string | null, category?: string | null, dialog?: string | null, imgUrl?: string | null, postActionText?: string | null, description?: string | null, killsPet: boolean, repeatable: boolean, targetStageId?: string | null, bodyTemperatureVariation: number, systolicPressureVariation: number, diastolicPressureVariation: number, heartRateVariation: number, respiratoryRateVariation: number, triggerDelay?: number | null, actionDelay?: number | null, scenarioId: string }> };

export type GetScenarioStageListQueryVariables = Exact<{
  scenarioId: Scalars['String']['input'];
}>;


export type GetScenarioStageListQuery = { __typename?: 'Query', getScenarioStageList: Array<{ __typename?: 'ScenarioStage', id: string, name: string, scenarioId: string, imgUrl?: string | null, imgUrlAvatar?: string | null, order: number, time: number, dialog?: string | null, startBodyTemperature: number, startSystolicPressure: number, startDiastolicPressure: number, startHeartRate: number, startRespiratoryRate: number, conditionActionIds: Array<string>, ScenarioAction?: Array<{ __typename?: 'ScenarioAction', id: string, name: string, subname?: string | null, category?: string | null, dialog?: string | null, imgUrl?: string | null, postActionText?: string | null, description?: string | null, killsPet: boolean, repeatable: boolean, targetStageId?: string | null, bodyTemperatureVariation: number, systolicPressureVariation: number, diastolicPressureVariation: number, heartRateVariation: number, respiratoryRateVariation: number, triggerDelay?: number | null, actionDelay?: number | null, scenarioId: string } | null> | null }> };

export type GetUserResultListQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserResultListQuery = { __typename?: 'Query', getUserResultList: Array<{ __typename?: 'UserResult', id: string, userId: string, scenarioId: string, scenarioName: string, createdAt: any, scenarioLog: Array<any> }> };

export type RollApiKeyMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type RollApiKeyMutation = { __typename?: 'Mutation', rollApiKey: string };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type UpdateUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UpdateUsernameMutation = { __typename?: 'Mutation', updateUsername: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string } };

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string } };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', userId: string, username: string, email: string } };

export type ResetMyPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetMyPasswordMutation = { __typename?: 'Mutation', resetMyPassword: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string } };

export type RequestTwoFactorAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestTwoFactorAuthMutation = { __typename?: 'Mutation', requestTwoFactorAuth: string };

export type SetupTwoFactorAuthMutationVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type SetupTwoFactorAuthMutation = { __typename?: 'Mutation', setupTwoFactorAuth: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, organizationId: string } };

export type CreateUserResultMutationVariables = Exact<{
  userResult: CreateUserResultInput;
}>;


export type CreateUserResultMutation = { __typename?: 'Mutation', createUserResult: { __typename?: 'UserResult', id: string, userId: string, scenarioId: string, createdAt: any, scenarioLog: Array<any> } };

export const UserFragmentDoc = gql`
    fragment User on User {
  userId
  username
  email
  has2fa
  organizationId
}
    `;
export const ScenarioFragmentDoc = gql`
    fragment Scenario on Scenario {
  id
  name
  animalType
  duration
  preScenarioInfo
  postScenarioInfo
  hints
  goal
}
    `;
export const ScenarioActionFragmentDoc = gql`
    fragment ScenarioAction on ScenarioAction {
  id
  name
  subname
  category
  dialog
  imgUrl
  postActionText
  description
  killsPet
  repeatable
  targetStageId
  bodyTemperatureVariation
  systolicPressureVariation
  diastolicPressureVariation
  heartRateVariation
  respiratoryRateVariation
  triggerDelay
  actionDelay
  scenarioId
}
    `;
export const ScenarioStageFragmentDoc = gql`
    fragment ScenarioStage on ScenarioStage {
  id
  name
  scenarioId
  imgUrl
  imgUrlAvatar
  order
  time
  dialog
  startBodyTemperature
  startSystolicPressure
  startDiastolicPressure
  startHeartRate
  startRespiratoryRate
  ScenarioAction {
    ...ScenarioAction
  }
  conditionActionIds
}
    ${ScenarioActionFragmentDoc}`;
export const GetUserDocument = gql`
    query getUser {
  getUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useGetUserQuery(options?: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetScenarioListDocument = gql`
    query getScenarioList {
  getScenarioList {
    ...Scenario
  }
}
    ${ScenarioFragmentDoc}`;

export function useGetScenarioListQuery(options?: Omit<Urql.UseQueryArgs<GetScenarioListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScenarioListQuery, GetScenarioListQueryVariables>({ query: GetScenarioListDocument, ...options });
};
export const GetScenarioDocument = gql`
    query getScenario($scenarioId: String!) {
  getScenario(scenarioId: $scenarioId) {
    ...Scenario
  }
}
    ${ScenarioFragmentDoc}`;

export function useGetScenarioQuery(options: Omit<Urql.UseQueryArgs<GetScenarioQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScenarioQuery, GetScenarioQueryVariables>({ query: GetScenarioDocument, ...options });
};
export const GetScenarioActionListDocument = gql`
    query getScenarioActionList($scenarioId: String!) {
  getScenarioActionList(scenarioId: $scenarioId) {
    ...ScenarioAction
  }
}
    ${ScenarioActionFragmentDoc}`;

export function useGetScenarioActionListQuery(options: Omit<Urql.UseQueryArgs<GetScenarioActionListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScenarioActionListQuery, GetScenarioActionListQueryVariables>({ query: GetScenarioActionListDocument, ...options });
};
export const GetScenarioStageListDocument = gql`
    query getScenarioStageList($scenarioId: String!) {
  getScenarioStageList(scenarioId: $scenarioId) {
    ...ScenarioStage
  }
}
    ${ScenarioStageFragmentDoc}`;

export function useGetScenarioStageListQuery(options: Omit<Urql.UseQueryArgs<GetScenarioStageListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScenarioStageListQuery, GetScenarioStageListQueryVariables>({ query: GetScenarioStageListDocument, ...options });
};
export const GetUserResultListDocument = gql`
    query getUserResultList($scenarioId: String) {
  getUserResultList(scenarioId: $scenarioId) {
    id
    userId
    scenarioId
    scenarioName
    createdAt
    scenarioLog
  }
}
    `;

export function useGetUserResultListQuery(options?: Omit<Urql.UseQueryArgs<GetUserResultListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserResultListQuery, GetUserResultListQueryVariables>({ query: GetUserResultListDocument, ...options });
};
export const RollApiKeyDocument = gql`
    mutation rollApiKey($organizationId: String!) {
  rollApiKey(organizationId: $organizationId)
}
    `;

export function useRollApiKeyMutation() {
  return Urql.useMutation<RollApiKeyMutation, RollApiKeyMutationVariables>(RollApiKeyDocument);
};
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const UpdateUsernameDocument = gql`
    mutation updateUsername($username: String!) {
  updateUsername(username: $username) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateUsernameMutation() {
  return Urql.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument);
};
export const UpdateEmailDocument = gql`
    mutation updateEmail($email: String!) {
  updateEmail(email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateEmailMutation() {
  return Urql.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument);
};
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    userId
    username
    email
  }
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const ResetMyPasswordDocument = gql`
    mutation resetMyPassword {
  resetMyPassword {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useResetMyPasswordMutation() {
  return Urql.useMutation<ResetMyPasswordMutation, ResetMyPasswordMutationVariables>(ResetMyPasswordDocument);
};
export const RequestTwoFactorAuthDocument = gql`
    mutation requestTwoFactorAuth {
  requestTwoFactorAuth
}
    `;

export function useRequestTwoFactorAuthMutation() {
  return Urql.useMutation<RequestTwoFactorAuthMutation, RequestTwoFactorAuthMutationVariables>(RequestTwoFactorAuthDocument);
};
export const SetupTwoFactorAuthDocument = gql`
    mutation setupTwoFactorAuth($secret: String!) {
  setupTwoFactorAuth(secret: $secret) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useSetupTwoFactorAuthMutation() {
  return Urql.useMutation<SetupTwoFactorAuthMutation, SetupTwoFactorAuthMutationVariables>(SetupTwoFactorAuthDocument);
};
export const CreateUserResultDocument = gql`
    mutation createUserResult($userResult: createUserResultInput!) {
  createUserResult(userResult: $userResult) {
    id
    userId
    scenarioId
    createdAt
    scenarioLog
  }
}
    `;

export function useCreateUserResultMutation() {
  return Urql.useMutation<CreateUserResultMutation, CreateUserResultMutationVariables>(CreateUserResultDocument);
};


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ANIMAL: Animal;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  Mutation: ResolverTypeWrapper<{}>;
  Organization: ResolverTypeWrapper<Organization>;
  Query: ResolverTypeWrapper<{}>;
  Scenario: ResolverTypeWrapper<Scenario>;
  ScenarioAction: ResolverTypeWrapper<ScenarioAction>;
  ScenarioStage: ResolverTypeWrapper<ScenarioStage>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  User: ResolverTypeWrapper<User>;
  UserResult: ResolverTypeWrapper<UserResult>;
  createUserResultInput: CreateUserResultInput;
  getUsersOfOrganization: ResolverTypeWrapper<GetUsersOfOrganization>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean']['output'];
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  Float: Scalars['Float']['output'];
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  Mutation: {};
  Organization: Organization;
  Query: {};
  Scenario: Scenario;
  ScenarioAction: ScenarioAction;
  ScenarioStage: ScenarioStage;
  String: Scalars['String']['output'];
  User: User;
  UserResult: UserResult;
  createUserResultInput: CreateUserResultInput;
  getUsersOfOrganization: GetUsersOfOrganization;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createUserResult?: Resolver<ResolversTypes['UserResult'], ParentType, ContextType, RequireFields<MutationCreateUserResultArgs, 'userResult'>>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestTwoFactorAuth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetMyPassword?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  rollApiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRollApiKeyArgs, 'organizationId'>>;
  setupTwoFactorAuth?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSetupTwoFactorAuthArgs, 'secret'>>;
  updateEmail?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'email'>>;
  updatePassword?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'newPassword' | 'oldPassword'>>;
  updateUsername?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUsernameArgs, 'username'>>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getScenario?: Resolver<ResolversTypes['Scenario'], ParentType, ContextType, RequireFields<QueryGetScenarioArgs, 'scenarioId'>>;
  getScenarioActionList?: Resolver<Array<ResolversTypes['ScenarioAction']>, ParentType, ContextType, RequireFields<QueryGetScenarioActionListArgs, 'scenarioId'>>;
  getScenarioList?: Resolver<Array<ResolversTypes['Scenario']>, ParentType, ContextType>;
  getScenarioStageList?: Resolver<Array<ResolversTypes['ScenarioStage']>, ParentType, ContextType, RequireFields<QueryGetScenarioStageListArgs, 'scenarioId'>>;
  getUser?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  getUserResultList?: Resolver<Array<ResolversTypes['UserResult']>, ParentType, ContextType, Partial<QueryGetUserResultListArgs>>;
};

export type ScenarioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Scenario'] = ResolversParentTypes['Scenario']> = {
  animalType?: Resolver<Maybe<ResolversTypes['ANIMAL']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  goal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hints?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postScenarioInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preScenarioInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioAction'] = ResolversParentTypes['ScenarioAction']> = {
  actionDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bodyTemperatureVariation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dialog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diastolicPressureVariation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  heartRateVariation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imgUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  killsPet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postActionText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  repeatable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  respiratoryRateVariation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scenarioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systolicPressureVariation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  targetStageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScenarioStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScenarioStage'] = ResolversParentTypes['ScenarioStage']> = {
  ScenarioAction?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScenarioAction']>>>, ParentType, ContextType>;
  conditionActionIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  dialog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imgUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imgUrlAvatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scenarioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startBodyTemperature?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startDiastolicPressure?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startHeartRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startRespiratoryRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startSystolicPressure?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  has2fa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserResult'] = ResolversParentTypes['UserResult']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scenarioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scenarioLog?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  scenarioName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetUsersOfOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['getUsersOfOrganization'] = ResolversParentTypes['getUsersOfOrganization']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  JSON?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Scenario?: ScenarioResolvers<ContextType>;
  ScenarioAction?: ScenarioActionResolvers<ContextType>;
  ScenarioStage?: ScenarioStageResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserResult?: UserResultResolvers<ContextType>;
  getUsersOfOrganization?: GetUsersOfOrganizationResolvers<ContextType>;
};

